// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__1J5ZD","list":"PatternAutocomplete_list__3-oiC"};